import React from "react";

import type { AlertProps } from "@mui/material/Alert";

import { Column } from "@rui/Stack";
import { Bold } from "@rui/styles";

import AlertBannerActions, {
  AlertBannerActionsProps,
} from "./AlertBannerActions";
import { Banner, Text } from "./styles";

export interface AlertBannerProps extends Omit<AlertProps, "action"> {
  action?: AlertBannerActionsProps["action"];
  contentVariant?: "text" | "custom";
  direction?: "column" | "row";
}

const AlertBanner = ({
  action,
  children,
  contentVariant = "text",
  direction = "row",
  title,
  onClose,
  ...props
}: AlertBannerProps) => {
  return (
    <Banner
      variant="outlined"
      action={
        <AlertBannerActions
          severity={props.severity}
          action={direction === "row" ? action : undefined}
          onClose={onClose}
        />
      }
      className={direction === "column" ? "column" : undefined}
      {...props}
    >
      <Column flex={1} variant="left" spacing={0.5}>
        {contentVariant === "custom" ? (
          children
        ) : (
          <Text>
            {title && <Bold>{title}: </Bold>}
            {children}
          </Text>
        )}
        {direction === "column" && (
          <AlertBannerActions severity={props.severity} action={action} />
        )}
      </Column>
    </Banner>
  );
};

export default AlertBanner;
